<template>
  <div class="pt-2 px-2">
      <work-time-mode-list
        v-if="!editMode"
        :results="results"
        @add="add"
        @edit="edit"
      />
    <div
      v-if="loading"
      id="loader"
      class="spinner"
    />
    <base-modal
      v-if="editMode"
      size="lg"
      hide-footer
      hide-header
      @close="showList"
    >
      <work-time-mode-editor
        :mode="workTimeMode"
        @close="showList"
        @close-and-update="closeAndUpdate"
      />
    </base-modal>
  </div>
</template>

<script>
import {restApi} from '../mixins/RestApiMixin'
import {workManagementHelper} from '../mixins/WorkManagementMixin'
import WorkTimeModeList from './WorkTimeModeList'
import WorkTimeModeEditor from './WorkTimeModeEditor'
import BaseModal from "@/components/BaseModal.vue"

export default {
    name: 'WorkTimeModes',
    components: {BaseModal, WorkTimeModeList, WorkTimeModeEditor},
    mixins: [restApi, workManagementHelper],
    data: function () {
        return {
            results: [],
            workTimeMode: null,
            editMode: false,
            loading: false
        }
    },
    mounted: function () {
        this.fetchItems()
    },
    methods: {
        fetchItems: function () {
            this.loading = true
            this.results = []
            this.restFetch(this.workTimeModeUrl, this.handleResponse)
        },
        handleResponse: function (response) {
            this.results = response.data
            this.loading = false
        },
        add: function () {
            this.workTimeMode = this.newWorkTimeMode()
            this.editMode = true
        },
        edit: function (wtMode) {
            this.workTimeMode = wtMode
            this.editMode = true
        },
        showList: function () {
            this.editMode = false
        },
        closeAndUpdate: function () {
            this.showList()
            this.fetchItems()
        }
    }
}
</script>
